import React from "react";
import InitialPropsContext from "../lib/models/initialPropsContext";
import PageNotFoundError from "../lib/pageNotFoundError";
import CategoryClusterPage, {
  Props
} from "../components/categoryCluster/CategoryClusterPage";
import PageProps from "../lib/models/pageProps";

export default function Program(props: Props) {
  return <CategoryClusterPage {...props} />;
}

Program.getInitialProps = async ({
  api,
  query
}: InitialPropsContext): PageProps<Props> => {
  const { categoryCluster } = query;
  const content = await api
    .loadCategoryClusterBySlug(categoryCluster as string)
    .catch(() => {
      throw new PageNotFoundError();
    });

  const [events, portraits, news] = await Promise.all([
    api
      .listExternalEvents({
        tags: {
          eq: content.segment.eventTags.map(tag => tag._id)
        }
      })
      .catch(() => ({ total: 0, items: [] })),
    api
      .listMagazinPortraits({
        limit: 3,
        orderBy: "date",
        order: "desc",
        categories: {
          eq: categoryCluster,
          path: "categoryCluster.slug"
        }
      })
      .catch(() => ({ total: 0, items: [] })),
    api
      .listMagazinNews({
        limit: 2,
        orderBy: "date",
        order: "desc",
        categories: {
          eq: categoryCluster,
          path: "categoryCluster.slug"
        }
      })
      .catch(() => ({ total: 0, items: [] }))
  ]);

  const pageProps = {
    ...content,
    events: events.items,
    portraits: portraits,
    news: news
  };
  let _pageImages;
  try {
    _pageImages = CategoryClusterPage.getImages(pageProps);
  } catch (error) {
    console.error(error);
  }

  return {
    ...pageProps,
    _pageImages
  };
};
